import { z } from "zod";
import { isReservationCode, normalizeReservationCode } from "@/domain/reservation/rules";

const missingCode = "Zadejte kód rezervace.";
const wrongShape =
  "Zkontrolujte prosím kód — má pět znaků, například K7M2P. " +
  "Písmena I a O ani číslice 0 a 1 se v kódech nepoužívají.";

export const codeLookupSchema = z.object({
  code: z.string().superRefine((typed, ctx) => {
    const code = normalizeReservationCode(typed);
    if (code === "") {
      ctx.addIssue({ code: z.ZodIssueCode.custom, message: missingCode });
      return;
    }
    if (!isReservationCode(code)) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, message: wrongShape });
    }
  }),
});

export type CodeLookupValues = z.infer<typeof codeLookupSchema>;
